@use "@design/design-tokens/typography/typography" as *;

@layer design-system {
  .wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 400px;
    margin: 0 auto;
    height: 100%;
  }

  .title {
    @include typography-v2-body-base;
    margin-bottom: 4px;
  }

  .errorIcon {
    margin-bottom: 8px;
  }

  .emptyIcon {
    width: 66px;
    height: 82px;
    margin-bottom: 8px;
    max-width: 600px;
  }

  .customIcon {
    margin-bottom: 8px;
  }

  .subtitle {
    color: var(--text-soft);
    @include typography-v2-body-sm;
    margin-bottom: 16px;
  }

  .link {
    color: var(--text-link);

    &:hover {
      color: var(--text-link);
    }
  }
}
